export const OPEN_SOURCE_GUIDE_URL = 'https://opensource.guide/'
